var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(!_vm.detail.show)?_c('div',{staticClass:"index"},[_vm._m(0),_c('div')]):_vm._e()])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"title"},[_c('div',{staticClass:"span1"},[_c('span',[_vm._v("通知公告")])])])
}]

export { render, staticRenderFns }